import { useCallback, useRef } from 'react';

export function useIntersectionObserver(callback, options) {
  const observerRef = useRef(null);

  const setTarget = useCallback(
    node => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      if (node) {
        const observer = new IntersectionObserver(callback, options);
        observer.observe(node);
        observerRef.current = observer;
      }
    },
    [callback, options]
  );

  return setTarget;
}
